export default () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    flexGrow: '1',
    paddingBottom: 12
  },
  instructions: {},
  tools: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  tool: {
    display: 'flex',
    gap: 16
  },
  toolContent: {
    display: 'flex',
    flexDirection: 'column'
  },
  toolCheckbox: {
    marginTop: 3
  }
});